var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 1H8.10001C7.42001 1 6.46 1.4 5.98 1.88L1.88 5.98001C1.4 6.46001 1 7.42001 1 8.10001V13.9C1 14.58 1.4 15.54 1.88 16.02L5.98 20.12C6.46 20.6 7.42001 21 8.10001 21H13.9C14.58 21 15.54 20.6 16.02 20.12L20.12 16.02C20.6 15.54 21 14.58 21 13.9V8.10001C21 7.42001 20.6 6.46001 20.12 5.98001L16.02 1.88C15.54 1.4 14.58 1 13.9 1Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93994 18.0804L18.0799 3.94043",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.4d3e996efb8f00ea4572585da9095d71.svg";
export { ForwardRef as ReactComponent };